import { Routes } from '@angular/router';
import { unauthenticatedGuard } from '@shared/guard/authentication.guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const loginRoute: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [unauthenticatedGuard],
    data: {
      title: 'Login',
      fullscreen: true,
      key: PageKey.LOGIN
    }
  },
  {
    path: 'oauth/callback',
    loadComponent: () => import('./pages/oauth-callback/oauth-callback.component').then(m => m.OAuthCallbackComponent),
    data: {
      title: 'Autenticando',
      fullscreen: true
    }
  }
];
